<template>
  <div class="allOrder" :style="listHeight">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      v-if="list.length != 0"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell class="lists" v-for="(item, index) in list" :key="index">
          <div>
            <van-row @click="detail(item.id)">
              <van-col span="24" class="title">
                <img
                  src="../../../assets/accountAgent/order/order_icon.png"
                  alt=""
                />
                代运营订单
                <span v-if="item.status == 10">退还申请中</span>
                <span v-if="item.status == -10">申请被驳回</span>
                <span v-if="item.status == 60">申请通过</span>
                <span v-if="item.status == 70">退款中</span>
                <span v-if="item.status == 80">退还成功</span>
                <span v-if="item.status == -20">已撤销</span>
              </van-col>
              <van-col span="24" class="phone_info">手机数量 1台</van-col>
              <van-col span="24" class="time">
                下单时间 {{ item.created_at }}
              </van-col>
              <van-col span="24" class="money">
                实付款<span class="num">￥<span>2000</span>.00</span>
              </van-col>
              <!-- <van-col span="24" class="tips" v-if="index == 0">
                红包补贴金额已累计：¥467.00
              </van-col> -->
            </van-row>
            <van-row>
              <van-col span="24" class="btns">
                <btn
                  :btntext="'查看协议'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#666'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #eee'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status > 20"
                  @btnClick="seeSinature(item)"
                />
                <btn
                  :btntext="'申请退还'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#666'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #eee'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status == -10"
                  @btnClick="refundPhone(item)"
                />
                <btn
                  :btntext="'联系客服'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#666'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #eee'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  @btnClick="contract"
                />
                <!-- <btn
                  :btntext="'删除订单'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#666'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #eee'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  @btnClick="delect(item)"
                /> -->
                <btn
                  :btntext="'撤销申请'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#F9591B'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #F9591B'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status == 10"
                  @btnClick="revoke(item)"
                />
              </van-col>
            </van-row>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <van-row class="empty" v-if="list.length == 0 && !hasList">
      <van-col class="emptyMsg" span="24">
        <img src="../../../assets/accountAgent/my/no_info.png" />
        <p class="tip">暂无订单</p>
      </van-col>
    </van-row>
    <div class="loading" v-if="list.length <= 0 && hasList">
      <img src="../../../assets/accountAgent/common/loading.gif" />
    </div>
    <a ref="phone" href="tel:4000571671"></a>
  </div>
</template>
<script>
import btn from "../components/button.vue";
export default {
  components: {
    btn,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      orderInfo: {},
      isiOSX: false,
      listHeight: {
        height: (document.body.clientHeight - 88) / 10 + "rem",
        padding: "4.4rem 1.2rem 0",
      },
      hasList: true,
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {},
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      this.$api
        .post("/investment/member/agent/order/after/list", {
          page: this.page,
        })
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
            this.timeout = true;
          } else {
            this.$toast(message);
          }
        });
    },
    detail(id) {
      this.$router.push({
        path: "/accountAgent/refundDetail",
        query: {
          orderId: id,
        },
      });
    },
    seeSinature(item) {
      this.$router.push({
        path: "/accountAgent/electroniContract",
        query: {
          ordersn: item.ordersn,
        },
      });
    },
    refundPhone(item) {
      this.$router.push({
        path: "/accountAgent/refund",
        query: {
          ordersn: item.ordersn,
        },
      });
    },
    contract() {
      this.$dialog
        .confirm({
          message: "4000571671",
          confirmButtonText: "立即呼叫",
          confirmButtonColor: "#f9591b",
          cancelButtonText: "取消",
          cancelButtonColor: "#999",
        })
        .then(() => {
          // on confirm
          // this.$refs.phone.click();
          // this.params("4000571671", "4000571671", "contract");
          let ua = navigator.userAgent.toLowerCase();
          if (
            /iphone|ipad|ipod|macintosh/i.test(ua) &&
            !this.$route.query.from
          ) {
            this.params("4000571671", "4000571671", "contract");
          } else {
            this.$refs.phone.click();
          }
        });
    },
    revoke(item) {
      this.$dialog
        .confirm({
          message: "您确定要撤销申请",
          confirmButtonText: "确定",
          confirmButtonColor: "#f9591b",
          cancelButtonText: "取消",
          cancelButtonColor: "#999",
        })
        .then(() => {
          // on confirm
          this.$api
            .post("investment/member/agent/order/after/cancel", { id: item.id })
            .then((res) => {
              this.$toast("申请已提交成功");
              var length = this.page;
              this.list = [];
              this.page = 0;
              for (var j = 0; j < length; j++) {
                this.page = j + 1;
                this.getInfo();
              }
            })
            .catch((err) => {
              this.hasList = false;
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              if (message.slice(0, 10) == "timeout of") {
                this.$toast("网络不给力，请稍候重试");
                this.timeout = true;
              } else {
                this.$toast(message);
              }
            });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.allOrder {
  background-color: #f5f6f7;
  min-height: 100%;
  box-sizing: border-box;

  .empty {
    padding-top: 10rem;

    .emptyMsg {
      text-align: center;

      img {
        width: 22.1rem;
        display: inline-block;
      }

      .tip {
        color: #cccccc;
        font-size: 1.4rem;
        margin-top: 1.7rem;
        height: 2rem;
        line-height: 2rem;
      }
    }
  }

  .loading {
    width: 100%;
    /*padding-top: 100px;*/
    text-align: center;

    img {
      width: 35%;
      margin-top: 50%;
    }
  }

  .van-pull-refresh {
    height: 100%;
    box-sizing: border-box;
    padding-top: 0.9rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .lists {
      min-height: 18.5rem;
      border-radius: 0.8rem;
      background: #fff;
      padding: 1.5rem 1.2rem;
      margin-bottom: 1rem;

      .title {
        color: #333;
        font-size: 1.5rem;
        text-align: left;
        height: 2.4rem;
        line-height: 2.4rem;

        img {
          width: 2rem;
          margin-right: 0.6rem;
          float: left;
          margin-top: 0.2rem;
        }

        span {
          color: #f9591b;
          font-size: 1.4rem;
          float: right;
        }
      }

      .phone_info {
        height: 2.1rem;
        line-height: 2.1rem;
        font-size: 1.3rem;
        color: #666666;
        margin-top: 1.2rem;
      }

      .time {
        height: 2.1rem;
        line-height: 2.1rem;
        font-size: 1.3rem;
        color: #666666;
        margin-top: 0.6rem;
      }

      .money {
        height: 2.1rem;
        line-height: 2.1rem;
        font-size: 1.3rem;
        color: #666666;
        margin-top: 0.6rem;
        text-align: right;

        .num {
          color: #333;

          span {
            font-size: 1.7rem;
            font-weight: 700;
          }
        }
      }

      .tips {
        color: #333;
        font-size: 1.4rem;
        text-align: center;
        background: #f5f6f7;
        height: 2.9rem;
        line-height: 2.9rem;
        margin-top: 1.2rem;
      }

      .btns {
        text-align: right;
      }
    }
  }
}
</style>
<style lang="less">
.van-dialog {
  border-radius: 0;

  .van-dialog__confirm,
  .van-dialog__cancel {
    height: 5.2rem;
    font-size: 1.6rem;
  }

  .van-dialog__content--isolated {
    min-height: 6.2rem;

    .van-dialog__message {
      padding: 2.1rem 1rem;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;
    }
  }
}
</style>